import { render, staticRenderFns } from "./RelatedProductV2.vue?vue&type=template&id=8f59346e"
import script from "./RelatedProductV2.vue?vue&type=script&lang=js"
export * from "./RelatedProductV2.vue?vue&type=script&lang=js"
import style0 from "./RelatedProductV2.vue?vue&type=style&index=0&id=8f59346e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports